// Axios Get actions
export const FETCH_TOKEN_DATA_SUCCESS = "FETCH_TOKEN_DATA_SUCCESS";
export const FETCH_TOKEN_DATA_PENDING = "FETCH_TOKEN_DATA_PENDING";
export const FETCH_TOKEN_DATA_ERROR = "FETCH_TOKEN_DATA_ERROR";

export const FETCH_HUB_DATA_SUCCESS = "FETCH_HUB_DATA_SUCCESS";
export const FETCH_HUB_DATA_PENDING = "FETCH_HUB_DATA_PENDING";
export const FETCH_HUB_DATA_ERROR = "FETCH_HUB_DATA_ERROR";

export const FETCH_COUNTRIES_DATA_PENDING = "FETCH_COUNTRIES_DATA_PENDING";
export const FETCH_COUNTRIES_DATA_SUCCESS = "FETCH_COUNTRIES_DATA_SUCCESS";
export const FETCH_COUNTRIES_DATA_ERROR = "FETCH_COUNTRIES_DATA_ERROR";

export const FETCH_PROJECTS_DATA_PENDING = "FETCH_PROJECTS_DATA_PENDING";
export const FETCH_PROJECTS_DATA_SUCCESS = "FETCH_PROJECTS_DATA_SUCCESS";
export const FETCH_PROJECTS_DATA_ERROR = "FETCH_PROJECTS_DATA_ERROR";

export const FETCH_SELECTED_PROJECT_DATA_PENDING =
  "FETCH_SELECTED_PROJECT_DATA_PENDING";
export const FETCH_SELECTED_PROJECT_DATA_SUCCESS =
  "FETCH_SELECTED_PROJECT_DATA_SUCCESS";
export const FETCH_SELECTED_PROJECT_DATA_ERROR =
  "FETCH_SELECTED_PROJECT_DATA_ERROR";

export const FETCH_SELECTED_PROJECT_ISSUES_DATA_PENDING =
  "FETCH_SELECTED_PROJECT_ISSUES_DATA_PENDING";
export const FETCH_SELECTED_PROJECT_ISSUES_DATA_SUCCESS =
  "FETCH_SELECTED_PROJECT_ISSUES_DATA_SUCCESS";
export const FETCH_SELECTED_PROJECT_ISSUES_DATA_ERROR =
  "FETCH_SELECTED_PROJECT_ISSUES_DATA_ERROR";

export const FETCH_USER_DATA_PENDING = "FETCH_USER_DATA_PENDING";
export const FETCH_USER_DATA_SUCCESS = "FETCH_USER_DATA_SUCCESS";
export const FETCH_USER_DATA_ERROR = "FETCH_USER_DATA_ERROR";

export const FETCH_LOGOUT_SUCCESS = "FETCH_LOGOUT_SUCCESS";
export const FETCH_LOGOUT_PENDING = "FETCH_LOGOUT_PENDING";
export const FETCH_LOGOUT_ERROR = "FETCH_LOGOUT_ERROR";

export const FETCH_FILE_WHITELIST_SUCCESS = "FETCH_FILE_WHITELIST_SUCCESS";
export const FETCH_FILE_WHITELIST_PENDING = "FETCH_FILE_WHITELIST_PENDING";
export const FETCH_FILE_WHITELIST_ERROR = "FETCH_FILE_WHITELIST_ERROR";

export const FETCH_FOLDER_BLACKLIST_SUCCESS = "FETCH_FOLDER_BLACKLIST_SUCCESS";
export const FETCH_FOLDER_BLACKLIST_PENDING = "FETCH_FOLDER_BLACKLIST_PENDING";
export const FETCH_FOLDER_BLACKLIST_ERROR = "FETCH_FOLDER_BLACKLIST_ERROR";

export const FETCH_FILTER_DATA_SET_SUCCESS = "FETCH_FILTER_DATA_SET_SUCCESS";
export const FETCH_FILTER_DATA_SET_PENDING = "FETCH_FILTER_DATA_SET_PENDING";
export const FETCH_FILTER_DATA_SET_ERROR = "FETCH_FILTER_DATA_SET_ERROR";

export const FETCH_FILTER_CATEGORY_SET_SUCCESS =
  "FETCH_FILTER_CATEGORY_SET_SUCCESS";
export const FETCH_FILTER_CATEGORY_SET_PENDING =
  "FETCH_FILTER_CATEGORY_SET_PENDING";
export const FETCH_FILTER_CATEGORY_SET_ERROR =
  "FETCH_FILTER_CATEGORY_SET_ERROR";

export const FETCH_GENERAL_SETTINGS_SUCCESS = "FETCH_GENERAL_SETTINGS_SUCCESS";
export const FETCH_GENERAL_SETTINGS_PENDING = "FETCH_GENERAL_SETTINGS_PENDING";
export const FETCH_GENERAL_SETTINGS_ERROR = "FETCH_GENERAL_SETTINGS_ERROR";

export const FETCH_PROJECT_DATA_CONFIG_SUCCESS =
  "FETCH_PROJECT_DATA_CONFIG_SUCCESS";
export const FETCH_PROJECT_DATA_CONFIG_PENDING =
  "FETCH_PROJECT_DATA_CONFIG_PENDING";
export const FETCH_PROJECT_DATA_CONFIG_ERROR =
  "FETCH_PROJECT_DATA_CONFIG_ERROR";

export const FETCH_CALCULATIONS_CONFIG_SUCCESS =
  "FETCH_CALCULATIONS_CONFIG_SUCCESS";
export const FETCH_CALCULATIONS_CONFIG_PENDING =
  "FETCH_CALCULATIONS_CONFIG_PENDING";
export const FETCH_CALCULATIONS_CONFIG_ERROR =
  "FETCH_CALCULATIONS_CONFIG_ERROR";

export const FETCH_REPORTS_CONFIG_SUCCESS = "FETCH_REPORTS_CONFIG_SUCCESS";
export const FETCH_REPORTS_CONFIG_PENDING = "FETCH_REPORTS_CONFIG_PENDING";
export const FETCH_REPORTS_CONFIG_ERROR = "FETCH_REPORTS_CONFIG_ERROR";

export const REQUEST_MARKDOWN_PENDING = "REQUEST_MARKDOWN_PENDING";
export const REQUEST_MARKDOWN_SUCCESS = "REQUEST_MARKDOWN_SUCCESS";
export const REQUEST_MARKDOWN_FAILED = "REQUEST_MARKDOWN_FAILED";

// Axios POST actions

export const POST_PROJECT_DATA = "POST_PROJECT_DATA";
export const POST_PROJECT_DATA_SUCCESS = "POST_PROJECT_DATA_SUCCESS";
export const POST_PROJECT_DATA_ERROR = "POST_PROJECT_DATA_ERROR";

export const POST_CALCULATIONS = "POST_CALCULATIONS";
export const POST_CALCULATIONS_SUCCESS = "POST_CALCULATIONS_SUCCESS";
export const POST_CALCULATIONS_ERROR = "POST_CALCULATIONS_ERROR";

// Actions
export const GET_AGGREGATE_PROPERTIES = "GET_AGGREGATE_PROPERTIES";
export const GET_SELECTED_PROJECT = "GET_SELECTED_PROJECT";
export const GET_SELECTED_MODEL = "GET_SELECTED_MODEL";
export const GET_REVIEW_MODE = "GET_REVIEW_MODE";
export const GET_STATE_OBJ_PROPERTIES = "GET_STATE_OBJ_PROPERTIES";
export const SELECTED_MODEL_ARRAY = "SELECTED_MODEL_ARRAY";
export const SET_TRAINING_DATA = "SET_TRAINING_DATA";

//Viewer.js
export const TOKEN_URL = process.env.REACT_APP_TOKEN_URL;

// READ from .env files
export const HUB_URL = process.env.REACT_APP_WEB_HUB_URL;
export const API_URL = process.env.REACT_APP_WEB_API_URL;
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;
export const LOGOUT_URL = process.env.REACT_APP_LOGOUT_URL;
export const USER_URL = process.env.REACT_APP_USER_URL;
export const ISSUE_URL = process.env.REACT_APP_ISSUE_URL;
export const HOST_URL = process.env.REACT_APP_HOST_URL;
export const VIEWER_API = process.env.REACT_APP_VIEWER_API;

//META PROPERTIES CONSTANTS
export const UPDATE_META_PROP_DATA = "UPDATE_META_PROP_DATA";
export const UPDATE_SELECTED_TAG = "UPDATE_SELECTED_TAG";
export const UPDATE_SELECTED_GUID = "UPDATE_SELECTED_GUID";
export const UPDATE_DYNA_PROP_VALUES = "UPDATE_DYNA_PROP_VALUES";
export const UPDATE_STAT_PROP_VALUES = "UPDATE_STAT_PROP_VALUES";
export const UPDATE_TAGS_CATS_LIST = "UPDATE_TAGS_CATS_LIST";
export const SHOW_TAGS_CATS_LIST = "SHOW_TAGS_CATS_LIST";
export const SHOW_META_PROP_TAG_LIST = "SHOW_META_PROP_TAG_LIST";
export const UPDATE_SELECTED_PROP_VALUES = "UPDATE_SELECTED_PROP_VALUES";
export const UPDATE_SELECTED_SCHEDULE = "UPDATE_SELECTED_SCHEDULE";
export const UPDATE_SHOW_ALL = "UPDATE_SHOW_ALL";
export const UPDATE_SHOW_SELECTION = "UPDATE_SHOW_SELECTION";
export const UPDATE_ADDITIONAL_TABS = "UPDATE_ADDITIONAL_TABS";

//MARKUP
export const UPDATE_MARKUP_STATE = "UPDATE_MARKUP_STATE";
export const SET_MARKUP_EXTENSION = "SET_MARKUP_EXTENSION";
export const GET_MARKUPS = "GET_MARKUPS";
export const SET_VIEWERAPP_STATE = "SET_VIEWERAPP_STATE";

//PDF
export const UPDATE_PDF_STATE = "UPDATE_PDF_STATE";
export const UPDATE_PDF = "UPDATE_PDF";

//WORKFLOW
export const UPDATE_WORKFLOW_STATE = "UPDATE_WORKFLOW_STATE";


